import AppShell from '@/components/AppShell'
import { Link } from 'react-router-dom'

export default function Unauthorized(){
  return (
    <AppShell title="Unauthorized">
      <div className="card">
        <div className="card-body text-sm">
          You don’t have permission to view this page.
          <div className="mt-3">
            <Link className="btn-secondary" to="/">Go to Dashboard</Link>
          </div>
        </div>
      </div>
    </AppShell>
  )
}
